import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { PoDataModel } from './po-data.model';


export class PoItemsResponseModel extends GlobalResponseObject {
    data?: PoDataModel;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: PoDataModel){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

